import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer("unlock", () => import("../ui/unlock-popup"))
